export default __webpack_public_path__ + "static/media/2.78c074cb.webp";